var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27005",
    "data-name": "Group 27005",
    transform: "translate(-76 -237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    transform: "translate(76 237)",
    fill: "#fff",
    stroke: "#1c1c1c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-map-pin",
    "data-name": "Icon feather-map-pin",
    transform: "translate(83.5 245.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37780",
    "data-name": "Path 37780",
    d: "M12.263.5a8.131,8.131,0,0,1,6.009,2.576,8.995,8.995,0,0,1,2.361,6.187,10.468,10.468,0,0,1-1.291,4.817,19.112,19.112,0,0,1-2.8,3.933,26.683,26.683,0,0,1-4.055,3.662.393.393,0,0,1-.444,0,27.618,27.618,0,0,1-4.252-3.66,19.146,19.146,0,0,1-2.937-3.933A10.1,10.1,0,0,1,3.5,9.263,8.756,8.756,0,0,1,12.263.5Zm-.006,20.37a27.067,27.067,0,0,0,3.713-3.4,18.3,18.3,0,0,0,2.678-3.764,9.689,9.689,0,0,0,1.2-4.446A8.211,8.211,0,0,0,17.7,3.614a7.352,7.352,0,0,0-5.434-2.327A7.969,7.969,0,0,0,4.287,9.263a9.329,9.329,0,0,0,1.26,4.447,18.365,18.365,0,0,0,2.817,3.769A27.938,27.938,0,0,0,12.258,20.87Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37781",
    "data-name": "Path 37781",
    d: "M15.683,9.5A3.183,3.183,0,1,1,12.5,12.683,3.187,3.187,0,0,1,15.683,9.5Zm0,5.58a2.4,2.4,0,1,0-2.4-2.4A2.4,2.4,0,0,0,15.683,15.08Z",
    transform: "translate(-3.42 -3.42)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.d21f58aea68c9c4780b0dbcf14bc345a.svg";
export { ForwardRef as ReactComponent };